import React from 'react';
import {Avatar, CardActionArea, CardContent, CardHeader, Chip, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getDataLabel} from "../../../../utils/TableUtils";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {red} from "@mui/material/colors";
import MailTwoToneIcon from '@mui/icons-material/MailTwoTone';
import SmsTwoToneIcon from '@mui/icons-material/SmsTwoTone';

const IntervistaIncompletaCard = ({intervista, onClickIntervista}) => {
	return (
        <React.Fragment>
            <Tooltip
				title={"Clicca per gestire: intervistare o lasciarla incompleta in caso il paziente non sia disponibile"}>
				<CardActionArea onClick={() => onClickIntervista(intervista)}>
					<CardHeader
						style={{paddingBottom: 2}}
						avatar={
							<Avatar>
								<SVG src={multiavatar(intervista?.id)}/>
							</Avatar>
						}
						title={<Typography variant={"subtitle1"} style={{position: "relative"}}>Intervista
							incompleta {intervista?.id}</Typography>}
						subheader={<Typography variant={"body2"} color={"textSecondary"}>
							Ultima modifica: <b>{getDataLabel(intervista.dataInserimento)}</b> da parte
							di <b>{intervista.lastModify}</b>
						</Typography>}
					/>
					<CardContent style={{paddingTop: 8}}>
						<Typography variant={"body2"} color={"textSecondary"}>
							{intervista?.note?.replaceAll(/#(\S*)/g, "")?.replaceAll("null", "")}
						</Typography>
						{
							intervista.sendMail &&
							<Chip
								label={"INVIATA MAIL"}
								avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}>
									<MailTwoToneIcon style={{fontSize: 16}}/>
								</Avatar>}
								color={"default"}
								style={{
									marginRight: 8,
									marginTop: 8,
									color: "#FFF",
									backgroundColor: red[400]
								}}/>
						}
						{
							intervista.sendSMS &&
							<Chip
								label={"INVIATO SMS"}
								avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}>
									<SmsTwoToneIcon style={{fontSize: 16}}/>
								</Avatar>}
								color={"default"}
								style={{
									marginRight: 8,
									marginTop: 8,
									color: "#FFF",
									backgroundColor: red[400]
								}}/>
						}
					</CardContent>
				</CardActionArea>
			</Tooltip>
        </React.Fragment>
    );
};

export default React.memo(IntervistaIncompletaCard)
